// 友だち紹介URL(?invite_ref=CODE)経由の帰属コードに関する共有定数。
//
// SignupPage が URL の invite_ref を localStorage に退避し、
// CompanyOnboardingPage がオンボーディング完了時に送信する。
// パートナー帰属コード（partner_ref）とは別系統で、両方が同時に付いていても
// それぞれ独立に効く。依存を持たないリーフモジュールに置く（循環 import 回避）。
export const INVITE_REF_STORAGE_KEY = 'tasky_invite_ref';

// サーバー側（InviteLink::CODE_LENGTH / OnboardingCompleteRequest）と揃える。
export const INVITE_REF_REGEX = /^[A-Za-z0-9]{1,32}$/;
